import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { buildFilterQuery } from '@sorare/core/src/components/search/InstantSearch/utils';
import { FOOTBALL_MARKET_NEW_SIGNINGS } from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import background from './assets/background.jpg';
import logo from './assets/logo.png';

const Background = styled(Vertical).attrs({ gap: 2, center: true })`
  height: 370px;
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  margin-top: var(--triple-unit);
  padding: var(--double-unit);
  border-radius: var(--unit);
  @media ${tabletAndAbove} {
    margin-top: var(--triple-unit);
  }
`;
const Logo = styled.img`
  max-width: 320px;
  height: auto;
  @media ${tabletAndAbove} {
    max-width: 400px;
  }
  @media ${laptopAndAbove} {
    max-width: 460px;
  }
`;

const Action = styled.div`
  flex-shrink: 0;
`;

export const FirstEditionWeek = () => {
  return (
    <Background>
      <Logo src={logo} width="1044" height="625" />
      <Action>
        <Button
          size="large"
          color="secondary"
          to={generatePath(
            `${FOOTBALL_MARKET_NEW_SIGNINGS}?${buildFilterQuery({
              [SEARCH_PARAMS.FIRST_EDITION_WEEK]: true,
            })}`
          )}
        >
          <FormattedMessage {...glossary.buy} />
        </Button>
      </Action>
    </Background>
  );
};
